
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Statistics from './components/Statistics';
import Testimonials from './components/Testimonials';
import QuoteForm from './components/QuoteForm';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SEOHead from '../../components/feature/SEOHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'First Insight Cleaning',
  description: 'Professional commercial janitorial services in Louisville, KY including office cleaning, medical facility sanitation, retail cleaning, industrial maintenance, and window cleaning.',
  url: siteUrl,
  telephone: '',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Louisville',
    addressRegion: 'KY',
    addressCountry: 'US',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 38.2527,
    longitude: -85.7585,
  },
  areaServed: {
    '@type': 'City',
    name: 'Louisville',
  },
  serviceType: [
    'Office Cleaning',
    'Medical Facility Cleaning',
    'Retail Cleaning',
    'Industrial Cleaning',
    'Window Cleaning',
    'Specialized Cleaning Services',
  ],
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '07:00',
      closes: '18:00',
    },
  ],
  sameAs: [],
};

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (location.state?.scrollTo) {
      const sectionId = location.state.scrollTo;
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const offset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="First Insight Cleaning | Commercial Janitorial Services Louisville KY"
        description="First Insight Cleaning delivers expert commercial janitorial services in Louisville, KY. Office cleaning, medical facility sanitation, retail cleaning, industrial maintenance, window cleaning &amp; specialized services. Free quote available."
        keywords="commercial cleaning Louisville KY, janitorial services Louisville, office cleaning Kentucky, First Insight Cleaning"
        canonical={`${siteUrl}/`}
        schemaJson={homeSchema}
      />
      <Navbar scrolled={scrolled} />
      <Hero />
      <Services />
      <Statistics />
      <Testimonials />
      <QuoteForm />
      <Contact />
      <Footer />
    </div>
  );
}
